"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    imageWrapper: {
      width: '100%',
      height: '100%',
      minHeight: 350
    },
    textWrapper: {
      animation: '$fadeInText .5s ease-in-out'
    },
    body: {
      margin: '25px 0'
    },
    swap: function swap(_ref) {
      var _swap = _ref.swap;
      return _defineProperty({
        order: _swap ? -1 : 0
      }, theme.breakpoints.down('md'), {
        order: 1
      });
    },
    '@keyframes fadeInText': {
      '0%': {
        opacity: 0,
        transform: 'translateY(-10px)'
      },
      '100%': {
        opacity: 1,
        transform: 'translateX(0)'
      }
    }
  };
});
var _default = useStyles;
exports["default"] = _default;